import {
  AfterViewInit,
  Component,
  ElementRef,
  Inject,
  Input,
  OnDestroy,
  PLATFORM_ID,
  Renderer2,
  ViewChild
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

const trail_lifespan = 75; // milliseconds
const trail_width = 4;
const trail_color = 'red';
const trail_offset_x = 1;
const trail_offset_y = 1;
const pntr_offset_x = -3;
const pntr_offset_y = -3;

@Component({
    selector: 'laser-pointer',
    template: `
      <div class="laser-pointer">
        <div class="pointer"></div>
        <canvas #laserCanvas class="laser-canvas"></canvas>
      </div>`,
    styleUrls: ['./laser-pointer.component.css'],
    standalone: false
})
export class LaserPointerComponent implements AfterViewInit, OnDestroy {
  @ViewChild('laserCanvas') canvasRef!: ElementRef<HTMLCanvasElement>;
  @Input() secondHearing: boolean
  @Input() firstHearing: boolean 

  private ctx!: CanvasRenderingContext2D;
  private points: { x: number; y: number, time: number }[] = [];
  private animationFrameId: any;
  private isBrowser: boolean;

  constructor(@Inject(PLATFORM_ID) platformId: Object, private renderer: Renderer2, private el: ElementRef) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  ngAfterViewInit(): void {
    if (!this.isBrowser) return; // Skip SSR execution

    const canvas = this.canvasRef.nativeElement;
    this.ctx = canvas.getContext('2d')!;
    this.resizeCanvas();

    window.addEventListener('resize', this.resizeCanvas.bind(this));
    window.addEventListener('mousemove', this.handleMouseMove.bind(this));

    this.animate();
  }

  ngOnDestroy(): void {
    if (!this.isBrowser) return; // Skip SSR cleanup
    cancelAnimationFrame(this.animationFrameId);
    window.removeEventListener('resize', this.resizeCanvas);
    window.removeEventListener('mousemove', this.handleMouseMove);
  }

  private resizeCanvas = () => {
    const canvas = this.canvasRef.nativeElement;
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
  }

  private handleMouseMove = (event: MouseEvent | TouchEvent) => {
    const e = event instanceof MouseEvent? event : event.touches[0];
    this.points.push({ x: e.clientX + trail_offset_x, y: e.clientY + trail_offset_y, time: Date.now() });
    let mouse_pos_x = e.clientX + pntr_offset_x, mouse_pos_y = e.clientY + pntr_offset_y;
    // if (this.points.length > 50) this.points.shift();
    const pointer = this.el.nativeElement.querySelector('.pointer') as HTMLElement;
    if (pointer) {
      this.renderer.setStyle(pointer, 'top', `${mouse_pos_y}px`);
      this.renderer.setStyle(pointer, 'left', `${mouse_pos_x}px`);
    }
  }
  getStrokeColor = (ageRatio) => {
    if (this.firstHearing) return `rgba(240,255,0, ${ageRatio})`; // Green
    if (this.secondHearing) return `rgba(45,85,255, ${ageRatio})`; // Red
  };
  // getPointerColor = () => {
  //   if (this.firstHearing) return 'yellow';
  //   if (this.secondHearing) return 'blue';
  //   return 'white'; // Default color
  // };
  private animate = () => {
    const canvas = this.canvasRef.nativeElement;
    this.ctx.fillStyle = 'rgba(255, 255, 255, 0.01)';
    this.ctx.clearRect(0, 0, canvas.width, canvas.height);
    this.ctx.fillRect(0, 0, canvas.width, canvas.height);

    const curr_time = Date.now();
    
    
    this.points = this.points.filter(point => curr_time - point.time < trail_lifespan);

    this.ctx.strokeStyle = trail_color;
    this.ctx.lineWidth = trail_width;
    this.ctx.beginPath();
    for (let i = 0; i < this.points.length - 1; i++) {
      const ageRatio = (trail_lifespan - (curr_time - this.points[i].time)) / trail_lifespan;
      // this.ctx.strokeStyle = this.getStrokeColor(ageRatio);
      this.ctx.strokeStyle = `rgba(255, 0, 0, ${ageRatio})`;
      this.ctx.moveTo(this.points[i].x, this.points[i].y);
      this.ctx.lineTo(this.points[i + 1].x, this.points[i + 1].y);
    }
    this.ctx.stroke();

    this.animationFrameId = requestAnimationFrame(this.animate);
  }
}
